import { useForm } from 'react-hook-form';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  HStack,
  Heading,
  Image,
  VStack,
  Button,
  Box,
  Select,
  Input,
} from '@chakra-ui/react';

import ReceiverNodeIcon from '../../../../assets/projects/receiver_node.svg';
import { WorkflowDurationForm } from '../../models';
import { DurationUnit } from '../../../../models';

export const WorkflowDurationModalOpen = ({
  isOpen,
  onClose,
  workflowDuration,
}: {
  isOpen: boolean;
  onClose: (workflowDurationForm?: WorkflowDurationForm) => void;
  workflowDuration?: WorkflowDurationForm;
}) => {
  const { handleSubmit, register } = useForm<WorkflowDurationForm>({
    defaultValues: {
      durationUnit: workflowDuration?.durationUnit,
      durationValue: Number(workflowDuration?.durationValue),
    },
  });

  const onSubmit = ({ durationUnit, durationValue }: WorkflowDurationForm) => {
    onClose({ durationUnit, durationValue: Number(durationValue) });
  };

  return (
    <Modal
      blockScrollOnMount={false}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      isCentered
    >
      <ModalOverlay />

      <ModalContent pb="4" borderRadius="md">
        <ModalHeader bg="custom_gray.5" borderTopRadius="md">
          <HStack>
            <Image src={ReceiverNodeIcon} />
            <Heading fontSize="md" fontWeight="medium" color="white">
              Workflow Duration
            </Heading>
          </HStack>
          <ModalCloseButton color="white" />
        </ModalHeader>
        <ModalBody>
          <VStack
            as="form"
            align="stretch"
            gap="2"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Box>
              <Select {...register('durationUnit')}>
                <option disabled>Duration Unit</option>
                {Object.keys(DurationUnit).map(unit => (
                  <option key={unit} value={unit}>
                    {unit}
                  </option>
                ))}
              </Select>
            </Box>

            <Box>
              <Input
                placeholder="Duration Value"
                type="number"
                {...register('durationValue')}
              />
            </Box>

            <HStack>
              <Button
                bg="custom_orange.2"
                _hover={{ bg: 'custom_orange.2' }}
                color="white"
                w="full"
                type="submit"
                mt="4"
              >
                Save
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
